<template>
  <div>
    <div class="mb-4">
      <a-spin :spinning="loading">
        <a-list :dataSource="data" class="neo-list">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            :class="handleSelectedListClass(item.id)"
            @click="handleListClick(item)"
          >
            <a-list-item-meta>
              <p slot="description">
                {{
                  item.enrollment[0].school_class
                    ? item.enrollment[0].school_class.name
                    : ""
                }}
                ({{
                  item.enrollment[0].section
                    ? item.enrollment[0].section.name
                    : ""
                }}) - Roll No: {{ item.enrollment[0].roll_no }}
              </p>
              <p slot="title" class="font-weight-bold mb-0">
                {{ item.first_name }} {{ item.last_name }}
              </p>
              <a-avatar :size="50" slot="avatar" :src="item.photo" />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IdCardTemplate',
  components: {},
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    data: function(val) {
      this.selectedStudentId = null
      this.selectedStudent = {}
    },
  },
  data: function() {
    return {
      selectedStudentId: null,
      selectedStudent: {},
    }
  },
  methods: {
    handleListClick(student) {
      this.selectedStudentId = student.id
      this.selectedStudent = student
      this.$emit('studentSelected', this.selectedStudent)
    },
    handleSelectedListClass(studentId) {
      if (this.selectedStudentId === studentId) {
        return 'neo-selected-list'
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
.neo-list {
  .ant-list-item:hover {
    cursor: pointer;
  }
}
.neo-selected-list {
  color: var(--theme-primary-color);

  .ant-list-item-meta-description,
  .ant-list-item-meta-title {
    color: var(--theme-primary-color);
  }
}
</style>
